<p-toast></p-toast>

<div *ngIf="document as doc else loading">
  <p-toolbar styleClass="">
    <ng-template pTemplate="left">
      <app-create-new-document [parentDocumentId]="doc.DOCID" [(display)]="displayND" (done)="onRefillDocument($event)"></app-create-new-document>

      <p-button label="New" icon="pi pi-plus" styleClass="p-button-success mr-2 hide-label" (onClick)="displayND=true" [disabled]="!canCreate"
                pTooltip="Новый документ (на основе)" tooltipPosition="top"></p-button>

      <app-create-new-document [parentDocumentId]="doc.PRIMDOCID" [selectedDocumentId]="doc.DOCID" [(display)]="displayMD" (done)="onRefillDocument($event)"></app-create-new-document>

      <p-button label="Заполнить..." icon="pi pi-pencil" styleClass="p-button-success mr-2 hide-label" (onClick)="displayMD=true"
                [disabled]="!doc.PRIMDOCID" pTooltip="Обновить на основе родительского документа" tooltipPosition="top"></p-button>

      <app-documents-tree [(display)]="displayDC" [documentId]="document.DOCID"></app-documents-tree>

      <p-button label="Дерево" icon="pi pi-sitemap" styleClass="p-button-help mr-2 hide-label" (onClick)="displayDC=true"
                pTooltip="Показать дерево документов" tooltipPosition="top"></p-button>

      <app-import-excel-dlg [(display)]="displayImportDlg"
                            [paramsMap]="importParamsMap"
                            header="Импорт из XLSX файла"
                            [document]="document"
                            (importIsDone)="onImportDone($event)">
      </app-import-excel-dlg>

      <p-button label="Import" icon="pi pi-upload" styleClass="p-button-info mr-2 hide-label" (onClick)="displayImportDlg=true" [disabled]="!canCreate"
                pTooltip="Импорт содержимого из XLSX файла" tooltipPosition="top"></p-button>

      <app-confirm-delete-product-part [(display)]="confirmDeleteDocumentOn"
                                       [typeConfirmation]="true"
                                       [confirmText]="confirmDeleteDocumentText"
                                       (done)="onDeleteDocumentConfirmation($event)">
      </app-confirm-delete-product-part>

      <p-button label="Delete" icon="pi pi-trash" styleClass="p-button-danger hide-label" (onClick)="deleteDocumentClick($event)"
                [disabled]="!canDelete" pTooltip="Удалить документ" tooltipPosition="top"></p-button>

    </ng-template>

    <ng-template pTemplate="right">
      <p-button label="Условия и примечания" icon="pi pi-exclamation-circle" styleClass="p-button-secondary mr-2 hide-label" (click)="showConditions($event)"
                [disabled]="false" pTooltip="Условия поставки и примечания документа" tooltipPosition="top"></p-button>

      <p-button label="Содержимое" icon="pi pi-table" styleClass="p-button-secondary mr-2 hide-label" (onClick)="showContent($event)"
                [disabled]="false" pTooltip="Табличная часть документа" tooltipPosition="top"></p-button>

      <p-button label="Движение" icon="pi pi-sort-alt" styleClass="p-button-secondary mr-6 hide-label" (onClick)="showTransactions($event)"
                [disabled]="false" pTooltip="Подчиненные документы" tooltipPosition="top"></p-button>

      <app-confirm-delete-product-part [(display)]="exportConfirmDlg"
                                       [typeConfirmation]="true"
                                       [confirmText]="confirmExportDocumentText"
                                       header="В документе есть замечания!"
                                       messageText="В документе есть замечания! Их необходимо устранить. Если вы считаете что все Ок, наберите кодовую фразу..."
                                       (done)="onExportDocumentConfirmation($event)"></app-confirm-delete-product-part>

      <app-export-document [(display)]="exportDS" [documentSpecific]="documentSpecific" [document]="doc" [countEmpty]="countEmpty" *ngIf="exportDS"></app-export-document>
      <p-button label="На печать" icon="pi pi-print" styleClass="p-button-info mr-2 hide-label" (onClick)="onExportDocument($event)"
                [disabled]="formInvalid || !noChangesThere"
                pTooltip="Сохранить документ для печати" tooltipPosition="top"></p-button>

      <p-button icon="pi pi-save" (onClick)="onConfirm(1)" styleClass="p-button-success mr-2" [disabled]="(formInvalid || noChangesThere)"
                pTooltip="Сохранить изменения" tooltipPosition="top"></p-button>
    </ng-template>
  </p-toolbar>

  <p-accordion [multiple]="true" (onOpen)="onTabOpen($event)">
    <p-accordionTab [selected]="showTabRowInfo" styleClass="">
      <ng-template pTemplate="header">
        <h3 style="line-height: 1; margin: 0.5rem">{{doc.DOCNAMESTR}}</h3>
      </ng-template>
      <app-edit-document-row-info appStopAccordionHomeEnd [document]="doc"></app-edit-document-row-info>
      <div class="grid formgrid justify-content-end">
        <p-button label="Скопировать название" icon="pi pi-copy" styleClass="p-button-information mt-2 mr-2" [cdkCopyToClipboard]="doc.DOCNAMESTR" (onClick)="copyClipBoard(doc.DOCNAMESTR)" pTooltip="Скопировать название в буфер обмена" tooltipPosition="top"></p-button>
        <p-button label="Сохранить" icon="pi pi-check" (onClick)="onConfirm(1)" styleClass="p-button-success mr-2" [disabled]="(formInvalid || noChangesThere)"></p-button>
      </div>
    </p-accordionTab>

    <p-accordionTab [selected]="showTabDetails" styleClass="">
      <ng-template pTemplate="header">
        <h5>Реквизиты, дата и сроки</h5>
      </ng-template>
      <div class="fluid formgrid grid" appStopAccordionHomeEnd>
        <div #DDN class="field col-2 xl:col-2 md:col-3 sm:col-6">
          <label for="DN" class="do-not-wrap-text">Номер документа</label>
          <input id="DN" type="text" pInputText [value]="doc.DOCNUMBEREX" readonly />
        </div>
        <div #DDP class="field col-2 xl:col-2 md:col-3 sm:col-6">
          <label for="DD" class="do-not-wrap-text">Дата документа</label>
          <p-calendar id="DD" showTime="true" dateFormat="dd.mm.yy" [(ngModel)]="DOCDATE" (onSelect)="onDateSelect($event)" showButtonBar="true" firstDayOfWeek="1"></p-calendar>
        </div>
        <div #DDE class="field col-2 xl:col-2 md:col-3 sm:col-6">
          <label for="DV" class="do-not-wrap-text">Действителен до</label>
          <p-calendar id="DV" dateFormat="dd.mm.yy" [(ngModel)]="DOCVALDATE" [minDate]="DOCDATE" (onSelect)="onDateValSelect($event)" showButtonBar="true" firstDayOfWeek="1"></p-calendar>
        </div>
        <div #DDV class="field col-2 xl:col-2 md:col-3 sm:col-6">
          <label for="DE" class="do-not-wrap-text">Дата выполнения</label>
          <p-calendar id="DE" dateFormat="dd.mm.yy" [(ngModel)]="DOCEXPDATE" [minDate]="DOCDATE" (onSelect)="onDateExpSelect($event)" showButtonBar="true" firstDayOfWeek="1"></p-calendar>
        </div>
        <div class="field col-4 xl:col-4 md:col-6 sm:col-12">
          <app-currencyselector #cs1 labelKey="Валюта документа {{doc.DOCRATEVAL}}" [selectedID]="doc.DOCCURRID" [_currencyDate]="DOCDATE" (SelectedCurrency)="onCurrencySelection($event)"></app-currencyselector>
        </div>
        <div class="field col-6 xl:col-6 md:col-6 sm:col-12">
          <app-security-group-selector #sgs1 labelKey="Группа доступа" [selectedID]="doc.SGMGROUPID" (selectedSecurityGroup)="onSelectedSecurityGroup($event)"></app-security-group-selector>
        </div>
        <div class="field col-6 xl:col-6 md:col-12 sm:col-12">
          <app-documentselector #ds1 labelKey="Первичный документ" [documentId]="doc.PRIMDOCID" (selectedDocument)="parentDocumentSelected($event)"></app-documentselector>
        </div>
      </div>
      <div class="grid formgrid justify-content-end">
        <p-button label="Сохранить" icon="pi pi-check" (onClick)="onConfirm(1)" styleClass="p-button-success mr-2" [disabled]="(formInvalid || noChangesThere)"></p-button>
      </div>
    </p-accordionTab>

    <p-accordionTab [selected]="false" styleClass="">
      <ng-template pTemplate="header">
        <h5>Преамбула и условия</h5>
      </ng-template>
      <div class="fluid formgrid grid" appStopAccordionHomeEnd>
        <div #DDH class="field col-12">
          <p-editor [(ngModel)]="docHeaderStatement" [style]="{'height':'20vw'}">
          </p-editor>
        </div>
        <div #DDF class="field col-12">
          <p-editor [(ngModel)]="docFooterStatement" [style]="{'height':'20vw'}">
          </p-editor>
        </div>
      </div>
    </p-accordionTab>

    <p-accordionTab [selected]="showTabSeller">
      <ng-template pTemplate="header">
        <h5>{{side1Label}}</h5>
      </ng-template>
      <app-edit-document-company appStopAccordionHomeEnd [document]="doc"
                                 [manCliLabel]="company1Label" [manPerLabel]="person1Label" [manDepLabel]="department1Label"
                                 [lcoCliLabel]="lcoLabel" [lcoPerLabel]="lcoPer1Label" [lcoDepLabel]="lcoDep1Label">
      </app-edit-document-company>
      <div class="grid formgrid justify-content-end">
        <p-button label="Сохранить" icon="pi pi-check" (onClick)="onConfirm(1)" styleClass="p-button-success mr-2" [disabled]="(formInvalid || noChangesThere)"></p-button>
      </div>
    </p-accordionTab>

    <p-accordionTab [selected]="showTabCustomer">
      <ng-template pTemplate="header">
        <h5>{{side2Label}}</h5>
      </ng-template>
      <app-edit-document-client appStopAccordionHomeEnd [document]="doc"
                                [cliCliLabel]="company2Label" [cliPerLabel]="person2Label" [cliDepLabel]="department2Label"
                                [pcoCliLabel]="pcoLabel" [pcoPerLabel]="pcoPer2Label" [pcoDepLabel]="pcoDep2Label">
      </app-edit-document-client>
      <div class="grid formgrid justify-content-end">
        <p-button label="Сохранить" icon="pi pi-check" (onClick)="onConfirm(1)" styleClass="p-button-success mr-2" [disabled]="(formInvalid || noChangesThere)"></p-button>
      </div>
    </p-accordionTab>

    <p-accordionTab [selected]="showTabConditions">
      <ng-template pTemplate="header">
        <h5>Условия поставки и примечания</h5>
      </ng-template>
      <app-edit-document-conditions-receipt appStopAccordionHomeEnd [document]="doc"
                                            [docDelvConds]="conditions1Label"
                                            [docDelvTerms]="conditions2Label"
                                            [docNoteText1]="conditions3Label"
                                            [docNoteText2]="conditions4Label">
      </app-edit-document-conditions-receipt>

      <div class="grid formgrid justify-content-end">
        <p-button label="Сохранить" icon="pi pi-check" (onClick)="onConfirm(1)" styleClass="p-button-success mr-2" [disabled]="(formInvalid || noChangesThere)"></p-button>
      </div>
    </p-accordionTab>

    <p-accordionTab [selected]="showTabTable">
      <ng-template pTemplate="header">
        <h5>Товары: содержание документа</h5>
      </ng-template>
      <app-edit-document-content-receipt appStopAccordionHomeEnd [knockKnock]="knockKnock" [inputDocument]="document" (editing)="editing=$event" (getDocumentStatus)="document.DOCFLAG=$event"></app-edit-document-content-receipt>
    </p-accordionTab>

    <p-accordionTab [disabled]="!movementIsReady" [selected]="showTabTransaction">
      <ng-template pTemplate="header">
        <h5>Движение</h5>
      </ng-template>
      <app-document-transaction-table appStopAccordionHomeEnd [inputDocument]="doc"></app-document-transaction-table>
    </p-accordionTab>
  </p-accordion>
</div>
<ng-template #loading>
  <p>Документ загружается...</p>
</ng-template>
